export enum PackageState {
  waiting = 1,
  processing,
  processed,
  already_processed,
  unknown,
}

export interface TracknumQueueItem {
  rownum: number;
  tracknum: string;
  time: any;
  state: PackageState;
  packageDate: any;
  userInfo?: {
    id?: number;
    email?: string;
    client_code?: string;
    client_city?: string;
    first_name?: string;
    last_name?: string;
  };
}
